import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import {
  SEARCH_SORT_SCORE_ALPHA,
  SEARCH_SORT_ALPHA_ASC,
  SEARCH_SORT_ALPHA_DESC,
  SEARCH_SORT_DATE_ASC,
  SEARCH_SORT_DATE_DESC,
} from '../../modules/App/search.tsx';

const propTypes = {
  count: PropTypes.number,
  searchTerm: PropTypes.string,
  handleChange: PropTypes.func,
};

export default function SearchHeader(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { count, searchTerm, handleChange } = props;

  return (
    <>
      <div className="spacer"></div>
      <div className="search-header">
        <div className="search-header__term">
          {searchTerm
          ? <div>{`Search results for '${searchTerm}'`}</div>
          : <div>Enter a search term to refine results</div>
          }
        </div>
        <div className="search-header__centred-row">
          <div className="search-header__count">
            {!searchTerm && <>Showing all </>}
            <strong>{count}</strong> item(s)
            {searchTerm && <> matching your search terms.</>}
          </div>
            <div className="search-header__sort">
              Sort by:
              <select onChange={handleChange}>
                <option value={SEARCH_SORT_SCORE_ALPHA}>Relevance</option>
                <option value={SEARCH_SORT_ALPHA_ASC}>Alphabetical A-Z</option>
                <option value={SEARCH_SORT_ALPHA_DESC}>Alphabetical Z-A</option>
                <option value={SEARCH_SORT_DATE_DESC}>Newest-Oldest</option>
                <option value={SEARCH_SORT_DATE_ASC}>Oldest-Newest</option>
              </select>
            </div>
        </div>
        <div className="spacer spacer--end"></div>
      </div>
    </>
  );
}
